import styled from 'styled-components';
import { PRESSABLE } from '../../../styles/constants';
import { onMobile } from '../../../styles/onMobile';
import { Link } from '../../Link';
import { IconHealthEngine } from '../../icons/IconHealthEngine';
import { IconHealthEngineWithText } from '../../icons/IconHealthEngineWithText';

export const LogoLink = styled(Link)`
  ${PRESSABLE};
  align-items: center;
  display: flex;
  flex: 1;
  flex: 0 0 auto;
  justify-content: left;
`;

export const Logo = styled(IconHealthEngine)`
  height: 38px;
  width: 44px;

  ${onMobile} {
    height: 32px;
    width: 32px;
  }
`;

export const TextLogo = styled(IconHealthEngineWithText)`
  height: 32px;
  width: 160px;
`;

export const WhiteLabelRectangularLogo = styled.div`
  background: url(${props => props.theme.whiteLabelProps?.rectangularLogoUrl ?? ''});
  background-position-x: left;
  background-position-y: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 48px;
  max-width: 336px;
  width: 100%;
`;

export const WhiteLabelSquareLogo = styled.div`
  background: url(${props => props.theme.whiteLabelProps?.squareLogoUrl ?? ''});
  background-repeat: no-repeat;
  background-size: contain;
  height: 38px;
  width: 44px;

  ${onMobile} {
    height: 32px;
    width: 32px;
  }
`;
